(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bruno-catalog-load-more"] && !Shopify.designMode) return;
  try {
    // Shared five-book feedback. Only callers with an active request show it.
(() => {
  if (window.brunoSetLoadingBooks) return;
  window.brunoSetLoadingBooks = (target, active) => {
    if (!target) return;
    let books = target.previousElementSibling;
    if (!books?.matches('[data-bruno-loading-books]')) {
      if (!active) return;
      books = document.createElement('span');
      books.className = 'bruno-loading-books';
      books.dataset.brunoLoadingBooks = '';
      books.setAttribute('aria-hidden', 'true');
      for (let i = 0; i < 5; i++) books.append(document.createElement('span'));
      target.before(books);
    }
    books.hidden = !active;
  };
})();

if (!customElements.get('bruno-catalog-load-more')) {
  customElements.define('bruno-catalog-load-more', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.request?.abort();
      this.controller = new AbortController();
      this.root = this.closest('bruno-catalog');
      this.grid = document.getElementById(this.dataset.gridId);
      this.more = this.querySelector('[data-load-more]');
      this.fallback = this.querySelector('[data-load-fallback]');
      this.message = this.querySelector('[data-load-message]');
      this.count = this.querySelector('[data-load-count]');
      this.label = this.querySelector('[data-load-label]');
      this.initialUrl = location.href;
      this.loading = false;
      this.blocked = false;
      if (!this.root || !this.grid || !this.root.contains(this.grid)) return;
      const options = { signal: this.controller.signal };
      this.more?.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (!this.loading && !this.blocked) this.loadMore();
      }, options);
      this.querySelector('[data-load-top]')?.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = this.root.querySelector('[data-catalog-count]');
        if (!target) return;
        event.preventDefault();
        target.focus({ preventScroll: true });
        target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options);
      window.addEventListener('pagehide', () => this.request?.abort(), options);
      window.addEventListener('pageshow', event => { if (event.persisted) location.reload(); }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.request?.abort();
    }
    nextUrl() {
      const next = new URL(this.more.href, location.origin);
      const current = new URL(location.href);
      const page = next.searchParams.get(this.dataset.pageParam);
      if (next.origin !== current.origin || next.pathname !== current.pathname || !page || Number(page) !== Number(this.dataset.page) + 1) throw new Error('context');
      current.hash = '';
      current.searchParams.delete('section_id');
      current.searchParams.delete('sections');
      current.searchParams.set(this.dataset.pageParam, page);
      return current;
    }
    setBusy(busy) {
      this.loading = busy;
      window.brunoSetLoadingBooks(this.message.closest('.bc-load-footer__summary'), busy);
      this.grid.setAttribute('aria-busy', String(busy));
      this.more?.setAttribute('aria-disabled', String(busy));
      if (this.label) this.label.textContent = busy ? this.dataset.loading : this.dataset.more;
    }
    async loadMore() {
      if (!this.more || this.more.hidden || this.loading || this.blocked || this.closest('[hidden]')) return;
      this.setBusy(true);
      this.message.textContent = this.dataset.loading;
      this.fallback.hidden = true;
      const request = new AbortController();
      this.request = request;
      const timeout = setTimeout(() => request.abort(), 15000);
      try {
        if (location.href !== this.initialUrl) throw new Error('context');
        const pageUrl = this.nextUrl();
        this.more.href = pageUrl.href;
        this.fallback.href = pageUrl.href;
        const fetchUrl = new URL(pageUrl);
        fetchUrl.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(fetchUrl.href, { credentials: 'same-origin', cache: 'no-store', redirect: 'error', signal: request.signal });
        if (!response.ok) throw new Error('network');
        const html = await response.text();
        if (!this.isConnected || this.closest('[hidden]')) return;
        if (request.signal.aborted) throw new Error('network');
        if (location.href !== this.initialUrl) throw new Error('context');
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = doc.getElementById(this.dataset.gridId);
        const nextFooter = Array.from(doc.querySelectorAll('bruno-catalog-load-more')).find(item => item.dataset.sectionId === this.dataset.sectionId);
        if (!nextGrid || !nextFooter) throw new Error('context');
        if (nextFooter.dataset.customer !== this.dataset.customer || nextFooter.dataset.commercialState !== this.dataset.commercialState || nextFooter.dataset.total !== this.dataset.total || nextFooter.dataset.pageParam !== this.dataset.pageParam || Number(nextFooter.dataset.page) !== Number(this.dataset.page) + 1 || Number(nextFooter.dataset.rangeStart) !== Number(this.dataset.rangeEnd) + 1) throw new Error('context');
        const items = Array.from(nextGrid.children);
        const keys = new Set(Array.from(this.grid.children, item => item.dataset.catalogItem));
        if (!items.length || items.length !== Number(nextFooter.dataset.rangeEnd) - Number(nextFooter.dataset.rangeStart) + 1) throw new Error('context');
        for (const item of items) {
          if (!item.matches('li.bc-card[data-catalog-item]') || !item.dataset.catalogItem || keys.has(item.dataset.catalogItem)) throw new Error('context');
          keys.add(item.dataset.catalogItem);
        }
        const nextLink = nextFooter.querySelector('[data-load-more]');
        if (nextLink) {
          const destination = new URL(nextLink.getAttribute('href'), location.origin);
          if (destination.origin !== location.origin || destination.pathname !== pageUrl.pathname || Number(destination.searchParams.get(this.dataset.pageParam)) !== Number(nextFooter.dataset.page) + 1) throw new Error('context');
        }
        const fragment = document.createDocumentFragment();
        const imported = items.map(item => document.importNode(item, true));
        imported.forEach(item => fragment.append(item));
        this.grid.append(fragment);
        this.dataset.page = nextFooter.dataset.page;
        this.dataset.rangeEnd = nextFooter.dataset.rangeEnd;
        this.count.textContent = this.dataset.countTemplate.replaceAll('__COUNT__', String(this.grid.children.length)).replaceAll('__TOTAL__', this.dataset.total);
        const summary = this.root.querySelector('[data-catalog-count]');
        if (summary) summary.textContent = this.dataset.rangeTemplate.replaceAll('__FIRST__', this.dataset.rangeStart).replaceAll('__LAST__', this.dataset.rangeEnd).replaceAll('__TOTAL__', this.dataset.total);
        if (nextLink) {
          this.more.href = nextLink.getAttribute('href');
          this.fallback.href = nextLink.getAttribute('href');
          this.message.textContent = '';
        } else {
          this.more.hidden = true;
          this.message.textContent = this.dataset.complete;
        }
        imported[0].querySelector('a[href],button')?.focus({ preventScroll: true });
        imported[0].scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      } catch (error) {
        if (!this.isConnected || this.controller.signal.aborted) return;
        this.blocked = error.message === 'context';
        this.message.textContent = this.blocked ? this.dataset.changed : this.dataset.error;
        this.fallback.hidden = false;
        this.more.hidden = this.blocked;
        if (this.blocked) this.fallback.focus({ preventScroll: true });
      } finally {
        clearTimeout(timeout);
        if (this.request === request) {
          this.setBusy(false);
          if (this.label && this.message.textContent === this.dataset.error) this.label.textContent = this.dataset.retry;
        }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bruno-catalog-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bruno-catalog-menu')) {
    customElements.define('bruno-catalog-menu', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const header = document.getElementById(this.dataset.headerId);
        const dialog = this.querySelector('dialog');
        if (!header || !dialog || typeof dialog.showModal !== 'function') return;
        document.addEventListener('click', event => {
          if (!(event.target instanceof Element)) return;
          const trigger = event.target.closest('[data-bruno-catalog-open]');
          if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const isPortalShortcut = trigger.matches('[data-bruno-catalog-external=\"portal-shortcut\"]') && trigger.closest('.bruno-shortcuts');
          const isWholesaleHero = trigger.matches('.bruno-hero-catalog-link[data-bruno-catalog-external="wholesale-hero"]') && trigger.closest('.hero--bruno-wholesale');
          if (!header.contains(trigger) && !isPortalShortcut && !isWholesaleHero) return;
          trigger.setAttribute('aria-controls', dialog.id);
          event.preventDefault();
          if (dialog.open) return;
          this.returnFocus = trigger;
          dialog.showModal();
        }, { signal });
        dialog.addEventListener('click', event => {
          if (event.target instanceof Element && event.target.closest('[data-bruno-catalog-close]')) {
            dialog.close();
            return;
          }
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }, { signal });
        dialog.addEventListener('close', () => {
          if (this.returnFocus?.isConnected && this.returnFocus.getClientRects().length) this.returnFocus.focus({ preventScroll: true });
          else header.querySelector('.mh-menu > summary')?.focus({ preventScroll: true });
        }, { signal });
        const dismiss = () => { if (dialog.open) dialog.close(); };
        window.addEventListener('pageshow', dismiss, { signal });
        window.addEventListener('popstate', dismiss, { signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.querySelector('dialog[open]')?.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bruno-catalog-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => {
      const root = document.getElementById('bruno-distributor-catalog');
      const select = root?.querySelector('#bdc-model');
      if (!select || select.dataset.catalogPickerReady || !select.options.length) return;
      const label = root.querySelector('label[for="bdc-model"]');
      const picker = document.createElement('div');
      picker.className = 'bdcp';
      picker.innerHTML = '<div class="bdcp__control"><svg class="bdcp__search" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="10.5" cy="10.5" r="6.5"></circle><path d="m15.5 15.5 5 5"></path></svg><input id="bdcp-input" class="bdcp__input" type="text" role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="bdcp-options" aria-describedby="bdc-status" autocomplete="off" autocapitalize="none" spellcheck="false" placeholder="Busca tu catálogo"><button class="bdcp__toggle" type="button" tabindex="-1" aria-label="Mostrar catálogos" aria-controls="bdcp-options" aria-expanded="false"><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="m6 9 6 6 6-6"></path></svg></button></div><div class="bdcp__panel" hidden><div class="bdcp__header"><span class="bdcp__title">Elige tu catálogo</span><span class="bdcp__count" role="status" aria-live="polite" aria-atomic="true"></span></div><ul id="bdcp-options" class="bdcp__options" role="listbox" aria-label="Catálogos"></ul><p class="bdcp__empty" hidden>No encontramos catálogos. Prueba con otro nombre.</p></div>';
      const input = picker.querySelector('input');
      const toggle = picker.querySelector('button');
      const panel = picker.querySelector('.bdcp__panel');
      const list = picker.querySelector('.bdcp__options');
      const count = picker.querySelector('.bdcp__count');
      const empty = picker.querySelector('.bdcp__empty');
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('es').trim();
      const entries = Array.from(select.options).filter(option => !option.disabled).map((option, index) => ({ value: option.value, label: option.textContent.trim(), id: 'bdcp-option-' + index }));
      let results = entries;
      let active = -1;
      let isOpen = false;
      const selectedLabel = () => select.value ? select.selectedOptions[0]?.textContent.trim() || '' : '';
      const activate = (index, scroll = true) => {
        active = index;
        Array.from(list.children).forEach((item, itemIndex) => item.toggleAttribute('data-active', itemIndex === active));
        if (active < 0 || !list.children[active]) { input.removeAttribute('aria-activedescendant'); return; }
        const item = list.children[active];
        input.setAttribute('aria-activedescendant', item.id);
        if (scroll) {
          const itemBox = item.getBoundingClientRect();
          const listBox = list.getBoundingClientRect();
          if (itemBox.top < listBox.top) list.scrollTop += itemBox.top - listBox.top;
          else if (itemBox.bottom > listBox.bottom) list.scrollTop += itemBox.bottom - listBox.bottom;
        }
      };
      const render = query => {
        const term = normalize(query);
        results = entries.filter(entry => !term || normalize(entry.label).includes(term));
        list.replaceChildren(...results.map(entry => {
          const item = document.createElement('li');
          item.className = 'bdcp__option';
          item.id = entry.id;
          item.setAttribute('role', 'option');
          item.setAttribute('aria-selected', String(entry.value === select.value));
          item.textContent = entry.label;
          return item;
        }));
        count.textContent = term && results.length === 1 && !results[0].value ? results[0].label : 'Resultados: ' + results.filter(entry => entry.value).length;
        empty.hidden = results.length !== 0;
        list.hidden = !results.length;
        list.scrollTop = 0;
        activate(-1);
      };
      const open = () => {
        if (isOpen) return;
        isOpen = true;
        picker.setAttribute('data-open', '');
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-label', 'Ocultar catálogos');
        render('');
        input.select();
      };
      const close = () => {
        isOpen = false;
        picker.removeAttribute('data-open');
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Mostrar catálogos');
        input.value = selectedLabel();
        activate(-1, false);
      };
      const choose = entry => {
        if (!entry) return;
        select.value = entry.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        close();
      };
      input.value = selectedLabel();
      input.addEventListener('focus', open);
      input.addEventListener('click', open);
      input.addEventListener('input', () => { if (!isOpen) open(); render(input.value); });
      input.addEventListener('keydown', event => {
        if (event.isComposing) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          open();
          if (results.length) activate(active < 0 ? event.key === 'ArrowDown' ? 0 : results.length - 1 : (active + (event.key === 'ArrowDown' ? 1 : -1) + results.length) % results.length);
        } else if (event.key === 'Enter' && isOpen) {
          event.preventDefault();
          choose(results[active < 0 && results.length === 1 ? 0 : active]);
        } else if (event.key === 'Escape' && isOpen) { event.preventDefault(); close(); }
        else if (event.key === 'Tab') close();
        else if (isOpen && active >= 0 && (event.key === 'Home' || event.key === 'End')) { event.preventDefault(); activate(event.key === 'Home' ? 0 : results.length - 1); }
      });
      toggle.addEventListener('pointerdown', event => event.preventDefault());
      toggle.addEventListener('click', () => { if (isOpen) close(); else { input.focus({ preventScroll: true }); open(); } });
      list.addEventListener('pointerdown', event => { if (event.target.closest('[role="option"]')) event.preventDefault(); });
      list.addEventListener('pointermove', event => { const item = event.target.closest('[role="option"]'); if (item) activate(Array.from(list.children).indexOf(item), false); });
      list.addEventListener('click', event => { const item = event.target.closest('[role="option"]'); if (item) choose(results[Array.from(list.children).indexOf(item)]); });
      picker.addEventListener('focusout', event => { if (!picker.contains(event.relatedTarget)) close(); });
      document.addEventListener('pointerdown', event => { if (isOpen && !picker.contains(event.target)) close(); });
      select.addEventListener('change', () => { input.value = selectedLabel(); if (isOpen) render(''); });
      if (label) { label.htmlFor = input.id; }
      else input.setAttribute('aria-label', 'Elegir catálogo');
      select.after(picker);
      select.classList.add('bdcp-native');
      select.dataset.catalogPickerReady = 'true';
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bruno-moto-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    // Keep one lifecycle for the document, including repeated theme-editor script loads.
    if (window.brunoMotoSelectorLifecycle) {
      window.brunoMotoSelectorLifecycle.initialize();
      return;
    }
    const lifecycle = window.brunoMotoSelectorLifecycle = { autoOpened: false, instances: new Map() };
    const initialize = () => {
      lifecycle.instances.forEach((cleanup, root) => { if (!root.isConnected) cleanup(); });
      document.querySelectorAll('[data-bruno-moto]:not([data-ready])').forEach((root) => {
      root.dataset.ready = 'true';
      const controller = new AbortController();
      const listen = (target, type, handler) => target.addEventListener(type, handler, { signal: controller.signal });
      const dialog = root.querySelector('dialog');
      if (typeof dialog.showModal !== 'function') return;
      const form = root.querySelector('[data-moto-form]');
      const brandInput = root.querySelector('[data-moto-brand]');
      const modelInput = root.querySelector('[data-moto-model]');
      const yearInput = root.querySelector('[data-moto-year]');
      const brandList = root.querySelector('[data-moto-brands]');
      const modelList = root.querySelector('[data-moto-models]');
      const accept = root.querySelector('[data-moto-accept]');
      const status = root.querySelector('[data-moto-status]');
      const launcher = root.querySelector('[data-moto-open]');
      const summary = root.querySelector('[data-moto-summary]');
      const advisor = root.querySelector('[data-moto-advisor]');
      const storageKey = 'bruno_moto_selection_v1';
      const maxYear = new Date().getFullYear() + 1;
      let catalog = [];
      let loading;
      let priorFocus;
      let priorOverflow = '';
      let activeCombo = null;
      yearInput.max = String(maxYear);
      try { window.localStorage.removeItem(storageKey); } catch {}
      const findBrand = () => catalog.find((brand) => brand.name === brandInput.value.trim());
      const findModel = () => findBrand()?.models.find((model) => model.name === modelInput.value.trim());
      const validYear = (value) => /^\d{4}$/.test(String(value)) && Number(value) >= 1885 && Number(value) <= maxYear;
      const selection = () => {
        const brand = findBrand();
        const model = findModel();
        if (!brand || !model || (yearInput.value && !validYear(yearInput.value))) return null;
        return { year: yearInput.value ? Number(yearInput.value) : null, brand: brand.name, model: model.name };
      };
      const updateAdvisor = () => {
        const moto = selection();
        let message = root.dataset.advisorGeneric;
        if (moto) message = (moto.year ? root.dataset.advisorSelection : root.dataset.advisorSelectionWithoutYear).replace('__year__', String(moto.year)).replace('__brand__', moto.brand).replace('__model__', moto.model);
        advisor.href = `https://wa.me/51947416982?text=${encodeURIComponent(message)}`;
      };
      const makeCombo = (kind, input, list, items) => ({
        input, list, items,
        field: root.querySelector(`[data-moto-${kind}-field]`),
        panel: root.querySelector(`[data-moto-${kind}-panel]`),
        count: root.querySelector(`[data-moto-${kind}-count]`),
        empty: root.querySelector(`[data-moto-${kind}-empty]`),
        results: [], active: -1
      });
      const brandCombo = makeCombo('brand', brandInput, brandList, () => catalog);
      const modelCombo = makeCombo('model', modelInput, modelList, () => findBrand()?.models || []);
      const closeCombo = () => {
        if (!activeCombo) return;
        activeCombo.panel.hidden = true;
        activeCombo.input.setAttribute('aria-expanded', 'false');
        activeCombo.input.removeAttribute('aria-activedescendant');
        activeCombo.input.removeAttribute('aria-describedby');
        activeCombo.active = -1;
        activeCombo = null;
      };
      const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      const renderOptions = (combo, showAllForExact) => {
        const items = combo.items();
        const exactValue = combo.input.value.trim();
        const query = showAllForExact && items.some((item) => item.name === exactValue) ? '' : normalize(exactValue);
        combo.results = items.filter((item) => normalize(item.name).includes(query));
        combo.active = -1;
        combo.input.removeAttribute('aria-activedescendant');
        const fragment = document.createDocumentFragment();
        combo.results.forEach((item, index) => {
          const option = document.createElement('div');
          option.id = `${combo.list.id}Option${index}`;
          option.className = 'bruno-moto__option';
          option.setAttribute('role', 'option');
          option.setAttribute('aria-selected', String(item.name === exactValue));
          option.dataset.optionIndex = String(index);
          const name = document.createElement('span');
          name.textContent = item.name;
          option.append(name);
          if (item.name === exactValue) {
            const check = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            check.setAttribute('viewBox', '0 0 24 24');
            check.setAttribute('fill', 'none');
            check.setAttribute('stroke', 'currentColor');
            check.setAttribute('stroke-width', '2');
            check.setAttribute('aria-hidden', 'true');
            const line = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            line.setAttribute('d', 'm5 12 4 4L19 6');
            check.append(line);
            option.append(check);
          }
          fragment.append(option);
        });
        combo.list.replaceChildren(fragment);
        combo.list.scrollTop = 0;
        const selectedOption = combo.list.querySelector('[aria-selected="true"]');
        if (showAllForExact && selectedOption) {
          const listBounds = combo.list.getBoundingClientRect();
          const selectedBounds = selectedOption.getBoundingClientRect();
          combo.list.scrollTop = Math.max(0, selectedBounds.top - listBounds.top - (combo.list.clientHeight - selectedBounds.height) / 2);
        }
        combo.count.textContent = root.dataset.resultsCount.replace('__count__', String(combo.results.length));
        combo.empty.hidden = combo.results.length > 0;
        if (combo.results.length) combo.input.removeAttribute('aria-describedby');
        else combo.input.setAttribute('aria-describedby', combo.empty.id);
      };
      const showCombo = (combo, showAllForExact = true) => {
        if (combo.input.disabled || !dialog.open) return;
        if (activeCombo !== combo) closeCombo();
        activeCombo = combo;
        combo.panel.hidden = false;
        combo.input.setAttribute('aria-expanded', 'true');
        renderOptions(combo, showAllForExact);
      };
      const activateOption = (combo, index) => {
        const option = combo.list.children[index];
        if (!option) return;
        for (const row of combo.list.children) row.removeAttribute('data-active');
        combo.active = index;
        option.dataset.active = 'true';
        combo.input.setAttribute('aria-activedescendant', option.id);
        const listBounds = combo.list.getBoundingClientRect();
        const optionBounds = option.getBoundingClientRect();
        if (optionBounds.top < listBounds.top) combo.list.scrollTop -= listBounds.top - optionBounds.top;
        else if (optionBounds.bottom > listBounds.bottom) combo.list.scrollTop += optionBounds.bottom - listBounds.bottom;
      };
      const chooseOption = (combo, index) => {
        const item = combo.results[index];
        if (!item) return;
        const changed = combo.input.value.trim() !== item.name;
        combo.input.value = item.name;
        combo.input.setCustomValidity('');
        if (combo === brandCombo && changed) { modelInput.value = ''; modelInput.setCustomValidity(''); }
        closeCombo();
        populateModels();
        updateAdvisor();
        combo.input.focus({ preventScroll: true });
      };
      for (const combo of [brandCombo, modelCombo]) {
        listen(combo.input, 'click', () => { if (activeCombo !== combo) showCombo(combo); });
        listen(combo.input, 'keydown', (event) => {
          if (event.isComposing) return;
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            if (activeCombo !== combo) showCombo(combo);
            const last = combo.results.length - 1;
            const next = event.key === 'ArrowDown' ? Math.min(combo.active + 1, last) : combo.active < 0 ? last : Math.max(0, combo.active - 1);
            activateOption(combo, next);
          } else if (event.key === 'Enter' && activeCombo === combo) {
            event.preventDefault();
            if (combo.active >= 0) chooseOption(combo, combo.active);
          } else if (event.key === 'Escape' && activeCombo === combo) {
            event.preventDefault(); event.stopPropagation(); closeCombo();
          } else if (event.key === 'Tab') closeCombo();
        });
        listen(combo.list, 'mousedown', (event) => { event.preventDefault(); });
        listen(combo.list, 'click', (event) => {
          const option = event.target instanceof Element ? event.target.closest('[data-option-index]') : null;
          if (option && combo.list.contains(option)) chooseOption(combo, Number(option.dataset.optionIndex));
        });
        listen(combo.list, 'pointermove', (event) => {
          if (event.pointerType !== 'mouse') return;
          const option = event.target instanceof Element ? event.target.closest('[data-option-index]') : null;
          if (option && combo.list.contains(option)) activateOption(combo, Number(option.dataset.optionIndex));
        });
      }
      const closeComboOutside = (event) => {
        if (activeCombo && event.target instanceof Node && !activeCombo.field.contains(event.target) && !activeCombo.panel.contains(event.target)) closeCombo();
      };
      listen(dialog, 'click', closeComboOutside);
      const populateModels = () => {
        const brand = findBrand();
        if (activeCombo === modelCombo) closeCombo();
        modelList.replaceChildren();
        modelInput.removeAttribute('aria-activedescendant');
        modelInput.disabled = !brand;
        modelInput.placeholder = brand ? root.dataset.modelReady : root.dataset.modelEmpty;
      };
      const loadCatalog = () => {
        if (catalog.length) return Promise.resolve(true);
        if (loading) return loading;
        status.textContent = root.dataset.loading;
        loading = fetch(root.dataset.catalogUrl, { credentials: 'omit', signal: controller.signal }).then((response) => {
          if (!response.ok) throw new Error('Catalog unavailable');
          return response.json();
        }).then((data) => {
          if (!Array.isArray(data.brands) || !data.brands.length) throw new Error('Invalid catalog');
          catalog = data.brands.filter((brand) => typeof brand.name === 'string' && Array.isArray(brand.models)).map((brand) => ({
            name: brand.name,
            models: brand.models.filter((model) => typeof model.name === 'string' && typeof model.tag === 'string' && /^bruno-moto-[a-z0-9-]+$/.test(model.tag) && typeof model.searchTag === 'string' && model.searchTag.length && !/["\\]/.test(model.searchTag))
          })).filter((brand) => brand.models.length);
          if (!catalog.length) throw new Error('Empty catalog');
          brandInput.disabled = false;
          accept.disabled = false;
          populateModels();
          status.textContent = '';
          return true;
        }).catch(() => { status.textContent = root.dataset.loadError; return false; }).finally(() => { loading = null; });
        return loading;
      };
      const resetSelection = () => {
        closeCombo();
        for (const input of [brandInput, modelInput, yearInput]) {
          input.value = '';
          input.setCustomValidity('');
          input.removeAttribute('aria-activedescendant');
          input.removeAttribute('aria-describedby');
          if (input !== yearInput) input.setAttribute('aria-expanded', 'false');
        }
        for (const combo of [brandCombo, modelCombo]) {
          combo.list.replaceChildren();
          combo.panel.hidden = true;
          combo.count.textContent = '';
          combo.empty.hidden = true;
          combo.results = [];
          combo.active = -1;
        }
        populateModels();
        status.textContent = loading ? root.dataset.loading : '';
        summary.textContent = '';
        summary.hidden = true;
        updateAdvisor();
      };
      resetSelection();
      listen(window, 'pageshow', resetSelection);
      const open = async () => {
        if (dialog.open || !root.isConnected) return;
        resetSelection();
        document.dispatchEvent(new CustomEvent('bruno:moto-selector:opening', { detail: { dialog } }));
        priorFocus = document.activeElement;
        priorOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        if (await loadCatalog()) { if (dialog.open) brandInput.focus({ preventScroll: true }); }
      };
      const dismiss = () => { dialog.close(); };
      launcher.hidden = false;
      listen(launcher, 'click', open);
      listen(document, 'bruno:moto-selector:opening', (event) => {
        if (event.detail?.dialog !== dialog && dialog.open) {
          dialog.close();
          document.body.style.overflow = priorOverflow;
        }
      });
      lifecycle.instances.set(root, () => {
        controller.abort();
        if (dialog.open) { dialog.close(); document.body.style.overflow = priorOverflow; }
        lifecycle.instances.delete(root);
        delete root.dataset.ready;
      });
      root.querySelectorAll('[data-moto-dismiss]').forEach((button) => listen(button, 'click', dismiss));
      listen(dialog, 'cancel', (event) => { event.preventDefault(); if (activeCombo) closeCombo(); else dismiss(); });
      listen(dialog, 'close', () => {
        closeCombo();
        if (document.querySelector('[data-bruno-moto] dialog[open], bruno-purchase-selector dialog[open]')) return;
        document.body.style.overflow = priorOverflow;
        if (priorFocus instanceof HTMLElement && priorFocus.isConnected) priorFocus.focus({ preventScroll: true });
      });
      listen(dialog, 'click', (event) => { if (event.target === dialog) dismiss(); });
      listen(brandInput, 'input', () => {
        brandInput.setCustomValidity(''); modelInput.value = ''; modelInput.setCustomValidity(''); populateModels(); updateAdvisor(); showCombo(brandCombo, false);
      });
      listen(modelInput, 'input', () => { modelInput.setCustomValidity(''); updateAdvisor(); showCombo(modelCombo, false); });
      listen(yearInput, 'input', () => { yearInput.setCustomValidity(''); updateAdvisor(); });
      listen(advisor, 'click', () => { updateAdvisor(); dialog.close(); });
      listen(form, 'submit', (event) => {
        event.preventDefault();
        closeCombo();
        brandInput.setCustomValidity(findBrand() ? '' : root.dataset.brandError);
        modelInput.setCustomValidity(findModel() ? '' : root.dataset.modelError);
        yearInput.setCustomValidity(!yearInput.value || validYear(yearInput.value) ? '' : root.dataset.yearError.replace('__max__', String(maxYear)));
        if (!form.reportValidity()) return;
        const moto = selection();
        const model = findModel();
        if (!moto || !model) return;
        const configuredEndpoint = root.dataset.recordEndpoint;
        if (configuredEndpoint) {
          try {
            const endpoint = new URL(configuredEndpoint, window.location.origin);
            if (endpoint.origin === window.location.origin && endpoint.pathname === '/apps/bruno-motos/selection' && !endpoint.search && !endpoint.hash) {
              void fetch(endpoint.href, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(moto), keepalive: true }).catch(() => {});
            }
          } catch {}
        }
        const destination = new URL(root.dataset.searchUrl, window.location.origin);
        destination.searchParams.set('q', window.brunoAres?.identify(model.searchTag) ? window.brunoAres.compose('', model.searchTag) : `tag:"${model.searchTag}"`);
        if (window.brunoAres?.identify(model.searchTag)) { destination.searchParams.set('bruno_model', window.brunoAres.identify(model.searchTag)); destination.searchParams.set('bruno_base_q', ''); }
        destination.searchParams.set('type', 'product');
        destination.searchParams.set('options[prefix]', 'none');
        const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (preview) destination.searchParams.set('preview_theme_id', preview);
        summary.textContent = `${moto.year ? `${moto.year} · ` : ''}${moto.brand} ${moto.model}`;
        summary.hidden = false;
        dialog.close();
        document.body.style.overflow = priorOverflow;
        window.location.assign(destination.href);
      });
      updateAdvisor();
      const catalogTitles = document.querySelectorAll('[data-bruno-moto-catalog-title]');
      const requestedTag = new URL(window.location.href).searchParams.get('bruno_model') || new URL(window.location.href).searchParams.get('q')?.match(/^tag:"([^"\\]+)"(?: AND product_type:"(?:[^"\\]|\\.)*")?$/)?.[1];
      if (catalogTitles.length && requestedTag) {
        void loadCatalog().then((loaded) => {
          if (!loaded) return;
          for (const brand of catalog) {
            const model = brand.models.find((item) => item.searchTag.toLowerCase() === requestedTag.toLowerCase() || item.tag === requestedTag);
            if (!model) continue;
            const title = `${brand.name} ${model.name}`;
            catalogTitles.forEach((element) => { element.textContent = title; });
            break;
          }
        });
      }
      if (root.dataset.pageType === 'index' && root.dataset.wholesaleCustomer !== 'true' && !document.querySelector('.bruno-portal[data-portal-state]') && !lifecycle.autoOpened) {
        lifecycle.autoOpened = true;
        if (window.location.hash !== '#bruno-purchase' && !document.querySelector('bruno-purchase-selector dialog[open]')) void open();
      }
      });
    };
    lifecycle.initialize = initialize;
    document.addEventListener('click', (event) => {
      if (event.target instanceof Element && event.target.closest('[data-bruno-moto-open]')) {
        event.preventDefault();
        document.querySelector('[data-bruno-moto] [data-moto-open]')?.click();
      }
    });
    document.addEventListener('shopify:section:unload', (event) => {
      lifecycle.instances.forEach((cleanup, root) => { if (event.target instanceof Node && event.target.contains(root)) cleanup(); });
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bruno-portal-email-login"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bruno-portal-email-login')) {
    customElements.define('bruno-portal-email-login', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const form = this.querySelector('[data-email-form]');
        const input = form.querySelector('input[type="email"]');
        const fallback = this.querySelector('[data-email-fallback]');
        form.addEventListener('submit', event => {
          event.preventDefault();
          if (!form.reportValidity()) return;
          const destination = new URL(this.dataset.loginUrl, window.location.origin);
          destination.searchParams.set('login_hint', input.value.trim());
          window.location.assign(destination.toString());
        });
        this.initialized = true;
        form.hidden = false;
        fallback.hidden = true;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bruno-product-information"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bruno-product-layout')) {
    customElements.define('bruno-product-layout', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const categories = this.querySelector('.bp-categories');
        const panel = this.querySelector('.product-details');
        const desktop = window.matchMedia('(min-width: 990px)');
        const updateSticky = () => {
          if (!panel) return;
          const offset = parseFloat(getComputedStyle(panel).getPropertyValue('--sticky-header-offset')) || 0;
          this.classList.toggle('bp-can-stick', desktop.matches && panel.offsetHeight + offset + 40 < window.innerHeight);
        };
        const updateLayout = () => { categories.open = desktop.matches; updateSticky(); };
        updateLayout();
        desktop.addEventListener('change', updateLayout, options);
        window.addEventListener('resize', updateSticky, options);
        this.observer?.disconnect();
        this.observer = new ResizeObserver(updateSticky);
        if (panel) this.observer.observe(panel);
        this.addEventListener('click', event => {
          if (!(event.target instanceof Element)) return;
          const anchor = event.target.closest('.bp-categories a, .bp-breadcrumb a');
          if (!anchor) return;
          const url = new URL(anchor.href, location.origin);
          if (url.origin !== location.origin) return;
          const current = new URL(location.href);
          for (const key of ['preview_theme_id', '_fd', 'pb']) {
            if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
          }
          anchor.href = url.href;
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bruno-wholesale-arrivals"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bruno-compact-arrivals')) {
    customElements.define('bruno-compact-arrivals', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        const groups = [];
        this.querySelectorAll('.bruno-arrivals__group').forEach(group => {
          const track = group.querySelector('.bruno-arrivals__products');
          const controls = group.querySelector('.bruno-arrivals__controls');
          if (!track || !controls) return;
          const previous = controls.querySelector('[data-arrivals-prev]');
          const next = controls.querySelector('[data-arrivals-next]');
          const update = () => {
            const maximum = track.scrollWidth - track.clientWidth;
            controls.hidden = maximum < 2;
            previous.disabled = track.scrollLeft < 2;
            next.disabled = track.scrollLeft >= maximum - 2;
          };
          const scroll = direction => {
            const card = track.querySelector('.bruno-arrivals__product');
            if (!card) return;
            const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
            const distance = Math.max(1, Math.floor(track.clientWidth / step)) * step;
            track.scrollBy({ left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          };
          previous.addEventListener('click', () => scroll(-1), { signal });
          next.addEventListener('click', () => scroll(1), { signal });
          track.addEventListener('scroll', update, { passive: true, signal });
          track.addEventListener('keydown', event => {
            if (event.target !== track) return;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
              event.preventDefault();
              scroll(event.key === 'ArrowLeft' ? -1 : 1);
            }
          }, { signal });
          groups.push({ track, update });
          update();
        });
        this.addEventListener('bruno:arrivals-updated', () => groups.forEach(group => group.update()), { signal });
        this.resizeObserver = new ResizeObserver(() => groups.forEach(group => group.update()));
        groups.forEach(group => this.resizeObserver.observe(group.track));
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bruno-wholesale-faq"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bruno-wholesale-faq')) {
    customElements.define('bruno-wholesale-faq', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const header = document.getElementById(this.dataset.headerId);
        const dialog = this.querySelector('dialog');
        if (!header || !dialog) return;
        header.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          const trigger = event.target.closest('[data-bruno-faq-open]');
          if (!trigger || !header.contains(trigger) || trigger.getAttribute('aria-controls') !== dialog.id) return;
          if (typeof dialog.showModal !== 'function') return;
          event.preventDefault();
          this.returnFocus = trigger.closest('.mh-menu')?.querySelector(':scope > summary') || trigger;
          if (typeof header.closeMenus === 'function') header.closeMenus();
          if (!dialog.open) dialog.showModal();
        }, { signal });
        dialog.addEventListener('click', (event) => {
          if (event.target instanceof Element && event.target.closest('[data-bruno-faq-close]')) dialog.close();
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }, { signal });
        dialog.addEventListener('close', () => {
          if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        }, { signal });
        window.addEventListener('pagehide', () => { if (dialog.open) dialog.close(); }, { signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.querySelector('dialog[open]')?.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rb-benefit-dialogs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rb-benefit-dialogs')) {
    customElements.define('rb-benefit-dialogs', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const header = document.getElementById(this.dataset.headerId);
        if (!header) return;
        header.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          const trigger = event.target.closest('[data-rb-help-open]');
          if (!trigger || !header.contains(trigger)) return;
          const dialog = this.querySelector('[data-rb-dialog="' + trigger.dataset.rbHelpOpen + '"]');
          if (!dialog || typeof dialog.showModal !== 'function') return;
          event.preventDefault();
          this.returnFocus = trigger;
          if (typeof header.closeMenus === 'function') header.closeMenus();
          if (!dialog.open) dialog.showModal();
        }, { signal });
        this.querySelectorAll('dialog').forEach((dialog) => {
          dialog.addEventListener('click', (event) => {
            if (event.target instanceof Element && event.target.closest('[data-rb-close]')) dialog.close();
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }, { signal });
          dialog.addEventListener('close', () => {
            if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
          }, { signal });
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
